import React, { useEffect } from "react";
import OurCommitmentsEfficientsupplychainImage from "../assets/img/Ourcommitments-Efficientsupplychain.jpg";
import OurCommitmentsGlobalexpansionImage from "../assets/img/Ourcommitments-Globalexpansion.jpg";
import OurCommitmentsInnovationinagricultureImage from "../assets/img/Ourcommitments-Innovationinagriculture.jpg";
import OurCommitmentsSustainabilityImage from "../assets/img/Ourcommitments-Sustainability.jpg";

const SlidingCard = ({ icon, title, description, img }) => {
  return (
    <div
      className="col-md-4 d-flex justify-content-center"
      data-aos="fade-left"
    >
      <div className="sliding-hover-card">
        {/* Front Side with Background Image */}
        <div
          className="sliding-card-front"
          style={{ backgroundImage: `url(${img})` }}
          data-aos="flip-left"
        >
          <div className="overlay"></div>
          <div className="content">
            <i className={`bi ${icon} sliding-icon`}></i>
            <h5 className="text-white fw-bold">{title}</h5>
          </div>
        </div>

        {/* Back Side with Background Color and Description */}
        <div className="sliding-card-back" data-aos="flip-right">
          <div className="content">
            <i className={`bi ${icon} sliding-icon-back`}></i>
            <h5 className="fw-bold">{title}</h5>
            <p className="text-light">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Features Data
const slidingFeatures = [
  {
    icon: "bi-lightning",
    title: "Innovation in Agriculture",
    description:
      "We strive for the best innovations to improve farming techniques and yield",
    img: OurCommitmentsInnovationinagricultureImage,
  },
  {
    icon: "bi-globe",
    title: "Global Expansion",
    description:
      "Our goal is to expand Indian pulses market across different countries.",
    img: OurCommitmentsGlobalexpansionImage,
  },
  {
    icon: "bi-leaf",
    title: "Sustainability & Environment",
    description:
      "Focusing on eco-friendly farming and sustainable agriculture.",
    img: OurCommitmentsSustainabilityImage,
  },
  {
    icon: "bi-truck",
    title: "Efficient Supply Chain",
    description:
      "Optimizing the supply chain for seamless and cost-effective distribution",
    img: OurCommitmentsEfficientsupplychainImage,
  },
];

const Objectives = () => {
  return (
    <div className="text-center py-5" data-aos="fade-up">
      <h2 className="separator-title" style={{ color: "#d4561a" }}>
        Our Commitments
      </h2>
      <div className="separator-line"></div>
      <p className="section-subtitle fw-bold mt-5">
        Driving Agriculture Forward
      </p>
      <div className="row justify-content-center">
        {slidingFeatures.map((feature, index) => (
          <SlidingCard key={index} {...feature} />
        ))}
      </div>
    </div>
  );
};

export default Objectives;
